import { ComingLater, PageHeader } from '@didto/ui';

export function PlaceholderPage({
  module,
  phase,
  detail,
}: {
  module: string;
  phase: string;
  detail?: string;
}) {
  return (
    <div className="d-page">
      <PageHeader eyebrow="didto. OS" title={module} />
      <ComingLater module={module} phase={phase} detail={detail} />
    </div>
  );
}
